<div class="max-width-p">
  <ng-container>
    <benefit-header-summary
      headerText="{{ 'FLEXIBLE_FIXED_BENEFITS.BENEFITS' | translate }} {{provider?.name}}"
      [smallText]="isEventMode
        ? ((activeEvent?.startDate | date: 'dd/MM/yyyy') + ' - ' + (activeEvent?.endDate | date: 'dd/MM/yyyy'))
        : ('FLEXIBLE_FIXED_BENEFITS.FLEXIBLE_BENEFITS_SMALL_TEXT' | translate)"
    >
    </benefit-header-summary>
  </ng-container>

  <div class="row">
    <div class="budget benefit-name col-12">
      <div class="left-content col-12">
        <div class="c-body">
          <div class="stacked-content mb-1">
            <img [src]="provider?.pictureUrl" [alt]="provider?.name" class="img" *ngIf="provider && !isEventMode" />
            <div class="text">
              <div [innerHtml]="provider?.description | sanitizeHtml"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <app-benefits-filter class="col-lg-3 filter-container"
                         *ngIf="dataLoadingDone"
                         [userCompanyInfo]="userCompanyInfo"
                         [providerId]="providerId"
                         [eventId]="eventId"
                         [itemCount]="displayedBenefits"
                         [itemType] = "'FLEXIBLE_FIXED_BENEFITS.COUNTER_BENEFITS'"
                         [applyFiltersBtnEnabled] = "benefitsOutdated"
                         (changeFilters)="changeFilters($event)"
                         (applyFilters)="applyFilters()"
                         (resetFilters)="resetAllFilters()">
    </app-benefits-filter>

    <div class="col-lg-9 benefit-cards">
      <div class="hide-on-mobile  benefits-count">{{totalBenefits}}  {{"FLEXIBLE_FIXED_BENEFITS.COUNTER_BENEFITS" | translate}}</div>
      <div class="offers" *ngIf="cards && cards.length > 0">
        <div class="medical-cards">
          <div
          class="card clickable"
          *ngFor="let card of cards"
          (click)="goToOtherOffer(card.id, card.providerId)"
        >
          <div *ngIf="card.discountPercentage"  class="discount-badge ">
            <span class="badge-text">-{{ card.discountPercentage }}%</span>
          </div>
          <div class="image">
            <img [src]="card.pictureUrl" alt="" role="presentation" height="100" class="img img-fluid" />
          </div>
          <div class="b-card">
            <div class="bold">{{ card.name }}</div>
            <div *ngIf="card.benefitTypeId !== BenefitType.Insurance" class="dark-green semi-bold">
              {{ card.price }} RON
              <span *ngIf="card.discountPercentage" class="old-price">
                {{ card.price / (100 - card.discountPercentage) * 100 | number:'1.2-2' }} RON
              </span>
              <span class="text-lowercase" *ngIf="ACQUISITION_TYPE.Subscription == card.acquisitionType">
                /{{ 'MONTH' | translate }}
              </span>
            </div>
            <a href="javascript:void(0)" class="card-link semi-bold c-company"
              >{{ 'FLEXIBLE_FIXED_BENEFITS.VIEW' | translate }}
              {{ 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFER' | translate }}
              <span class="ficon icon-chevron-right feather"></span>
            </a>
          </div>
        </div>
        </div>
      </div>
      <div class="row justify-content-center load-more-container">
        <button *ngIf="cards.length < totalBenefits" class="btn btn-secondary bold" (click)="loadMoreBenefits()">
          {{ 'FLEXIBLE_FIXED_BENEFITS.LOAD_MORE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
